<template>
  <div>
    <v-container>
      <h2 class="pt-5">Your Profile</h2>
    </v-container>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  components: {},
  computed: {},
  methods: {},
  mounted() {}
}
</script>

<style>

</style>